import React, {useEffect, useState} from "react";
import logo from '../../images/logo-gold.png'
import line from '../../images/zsline.png'
import {Certificates, companyCertificate} from "../types";
import {useLoading} from "../../components/loading/LoadingProvider";
import { getConditionList } from '../../service'

const classnames = require('classnames')
const names = ['一星证书', '二星证书', '三星证书']

function CompanyCertificate() {
    const [lists, setLists] = useState<Array<companyCertificate>>([])
    const loading = useLoading()
    const [text, setText] = useState<string>('')

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setText(event.target.value.replace(/\s/g, ''))
    }

    const handleClick = () => {
        if (text) {
            getConditionList({
                key: text
            }).then((res) => {
                setLists([])
                const lists = res.page.list
                if(res.page.list.length>0){
                    if((lists as Array<companyCertificate>).length > 0){
                        setLists(list => list.concat(lists))
                    }
                }else {
                    setText("");
                    loading.showError('暂无数据')
                }
            })
        }
    }

    return <div className="companyCertificate">
        <img src={logo} alt="" className='_logo'/>
        <div className="dis-input">
            <input type="text" placeholder="请输入证书编码查询" value={text} onChange={handleChange} />
            <div className={classnames("_btn", { 'active': text.length > 1 && text.length < 20 })} onClick={ handleClick } >查询</div>
        </div>
        <div className="lists" style={{ paddingBottom:'.3rem' }}>
            {
                lists.map((item, index) => {
                    return <div className="item" key={index}>
                        {
                            index > 0 && <img src={line} className='line' alt=""/>
                        }
                        {/*<Stars count={index + 1}/>*/}
                        <img src={ item.certificateUrl } className='zs' alt=""/>
                    </div>
                })
            }
        </div>
    </div>
}

export default CompanyCertificate;
